.mat-dialog-content{min-height:122px}
/*# sourceMappingURL=app-loader.component-GQJF4XAI.css.map */
